// extracted by mini-css-extract-plugin
export var wordContainer = "_rn-0";